import { Grid, Typography } from "@mui/material";
import EventosSA from "../../components/Table/Auditoria/EventosSA";
import {
  CustomTab,
  CustomTabs,
} from "../../components/Table/Auditoria/CustomItems";
import { useEffect, useState } from "react";
import { EventosProvider } from "../../context/SuperAdmin/EventsContext";
import { SublimacionProvider } from "../../context/SuperAdmin/SublimationContext";
import SublimacionesSA from "../../components/Table/Auditoria/SublimacionesSA";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../../hooks/Auth";

function AuditoriasPage() {
  const [isReportsTab, setIsReportsTab] = useState<0 | 1>(0);
  const { tipoAuditoria } = useParams();
  const navigate = useNavigate();
  const { canAccess, user } = useAuthContext();

  // Cuando se cambia de url, se cambia el tab
  useEffect(() => {
    if (tipoAuditoria === "eventos") setIsReportsTab(0);
    else if (tipoAuditoria === "sublimacion") setIsReportsTab(1);
  }, [tipoAuditoria]);

  // Función para cambiar de URL
  const handleNavigate = (newValue: 0 | 1) => {
    const isSuperAdmin = canAccess("view:reports");
    const section = newValue ? "sublimacion" : "eventos";
    let url = `/asistente/auditorias/${section}/organizacion`;
    if (!isSuperAdmin) url += `/${user?.id_organizacion}`;
    navigate(url);
  };

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
      }}
    >
      {/* Título */}
      <Grid item>
        <Typography variant={"h4"} sx={{ color: "#005559", fontSize: "30px" }}>
          <b>Reportes & Auditorías</b> | Actividad de la cuenta
        </Typography>
      </Grid>

      {/* Selección de tab Eventos o Sublimación */}
      <Grid item>
        <CustomTabs
          value={isReportsTab}
          onChange={(_, newValue: 0 | 1) => handleNavigate(newValue)}
          variant="fullWidth"
        >
          <CustomTab label="Eventos" />
          <CustomTab label="Sublimación" />
        </CustomTabs>
      </Grid>

      {/* Tab seleccionada. Si es 0, será Eventos */}
      <Grid item>
        {isReportsTab === 0 ? (
          <EventosProvider>
            <EventosSA />
          </EventosProvider>
        ) : (
          <SublimacionProvider>
            <SublimacionesSA />
          </SublimacionProvider>
        )}
      </Grid>
    </Grid>
  );
}

export default AuditoriasPage;
